/**
 * Loads the Google Maps JS API (with Places) without showing a map, so views that have no
 * visible map (e.g. table mode) can still use Places autocomplete.
 */
import { useEffect } from "react";
import GoogleMapReact from "google-map-react";

const HIDDEN_CENTER = { lat: 45.5152, lng: -122.6784 };

function isPlacesLoaded(): boolean {
  const w = window as unknown as { google?: { maps?: { places?: unknown } } };
  return Boolean(w.google?.maps?.places);
}

export function GoogleMapsLoader({ onLoaded }: { onLoaded: () => void }) {
  const alreadyLoaded = isPlacesLoaded();

  useEffect(() => {
    if (alreadyLoaded) onLoaded();
  }, [alreadyLoaded, onLoaded]);

  if (alreadyLoaded) return null;

  return (
    <div
      style={{ height: 1, width: 1, overflow: "hidden", position: "absolute", opacity: 0, pointerEvents: "none" }}
      aria-hidden
    >
      <GoogleMapReact
        bootstrapURLKeys={{ key: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || "", libraries: ["places", "geometry"] }}
        center={HIDDEN_CENTER}
        zoom={13}
        onGoogleApiLoaded={() => onLoaded()}
        yesIWantToUseGoogleMapApiInternals
      />
    </div>
  );
}
